/** @format */

import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { FormikProps } from "formik";
import * as React from "react";
import { useAppSelector } from "../../app/hooks";
import { selectApplicant } from "../../features/applicant/ApplicantSlice";
import { ApplicantViewDto, LegalGuardianDetailDependantsDto } from "../../features/applicant/Models";
import { ErrorBox } from "../custom/ErrorBox";

interface Props {
  formik: FormikProps<any>;
}
export default function ApplicantDepandents({ formik }: Props) {
  const selectApplicantData = useAppSelector(selectApplicant);
  const [data, setData] = React.useState<ApplicantViewDto>();

  React.useEffect(() => {
    if (selectApplicantData.applicantState.applicant) {
      setData(selectApplicantData.applicantState.applicant);
    }
  }, [selectApplicantData.applicantState.applicant]);

  return (
    <>
      {data && data.guardians && (
        <>
          <FormControl fullWidth>
            <InputLabel
              error={
                formik.touched.dependantId &&
                Boolean(formik.errors.dependantId)
              }
              id="demo-select-small"
            >
             Select Dependant
            </InputLabel>
            <Select
              required
              name="dependantId"
              labelId="demo-select-small"
              id="demo-select-small"
              value={formik.values.dependantId}
              label="Select Dependant"
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              error={
                formik.touched.dependantId &&
                Boolean(formik.errors.dependantId)
              }
            >
              <MenuItem value={-1} disabled>
              Select Dependant
              </MenuItem>
              {data.guardians[0].dependants?.map(
                (data: LegalGuardianDetailDependantsDto, key: number) => {
                  return (
                    <MenuItem key={key} value={data.id}>
                      {`${data.name} - ${data.guardianTypeOption}`}
                    </MenuItem>
                  );
                }
              )}
            </Select>
          </FormControl>


          <ErrorBox>
          {formik.touched.dependantId &&
              (formik.errors.dependantId as React.ReactNode)}
</ErrorBox>
         
        </>
      )}
    </>
  );
}
